import type FreeBusyType from '../schema/FreeBusyType';
import FreeBusyRanking from '../schema/FreeBusyRanking';

/**
 * Returns the most severe FreeBusy value
 * @param a
 * @param b
 */
export default function getMostSevereFreeBusy(a: FreeBusyType, b: FreeBusyType): FreeBusyType {
    let indexA = FreeBusyRanking.indexOf(a);
    let indexB = FreeBusyRanking.indexOf(b);

    return indexA > indexB ? a : b;
}
